import React from "react";

const style = {
  cols: {
    col1: "sm:grid-cols-1",
    col2: "sm:grid-cols-2",
    col3: "sm:grid-cols-3",
  },
};
export type filed = {
  [key: string]: any;
};

export type InfoBoardProps = {
  children: React.ReactNode;
  className?: string;
  col?: "col1" | "col2" | "col3";
  vertical?: boolean;
  filed: filed;
  flexDisp?: boolean;
};

export const InfoBoard = ({ filed, col = "col2", flexDisp = false }: InfoBoardProps) => {
  return (
    <div className={`${flexDisp? "mt-2" : "mt-6"} max-w-5xl px-4 sm:px-6 lg:px-8`}>
      <dl className={`grid grid-cols-1 gap-x-4 ${flexDisp? "gap-y-4" : "gap-y-8"} ${style.cols[col]}`}>
        {Object.keys(filed).map((field) => (
          <div key={field} className={`sm:col-span-1 ${flexDisp? "flex" : ""}`}>
            <dt className={`text-sm text-gray-500 ${flexDisp? "min-w-[110px] text-right mr-8 whitespace-nowrap" : ""}`}>{field}</dt>
            <dd className={`${flexDisp? "" : "mt-1"} text-sm text-gray-900 whitespace-pre-line`}>{filed[field]}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};


